module.exports = __webpack_public_path__ + "img/bb-logo-background.891bc04c.svg";